<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\ja\newManual\jonh_live_new_1.png" alt="" /></div>
                <div>
                    <p>①.ライブ中のライブ講義（ライブ講義名称、開催日、開始時間など）を確定し、ライブ講義名称をクリックするでコースに参加できます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\jonh_live_new_2.png" alt="" /></div>
                <div>
                    <p>②.「参加」ボタンを押下することでWeb会議室に入ります。</p>
                    <p>③.「参加」ボタンでWeb会議室に入室できない場合は、「予備」ボタンをクリックし、ライブl講義に参加してください。</p>
                    <p>&nbsp;&nbsp;※「予備」ボタンで入室した場合に、本コースでは出席を取られない為、講義が終了後自分で出席を取ってください。</p>
                </div>
                <div><img src="/static\images\ja\newManual\jonh_live_new_3.png" alt="" /></div>
                <div>
                    <p>④.ライブ講義は終わったら、該当ライブ講義を再度クリックしてください。 </p>
                </div>
                <div><img src="/static\images\ja\newManual\jonh_live_new_4.png" alt="" /></div>
                <div>
                    <p>⑤.終了したライブ講義をクリックすることで、上記のメッセージが表示されます。</p>
                    <p>「出席取る」ボタンをクリックすることで、ライブ講義に出席を取ることができます。 </p>
                </div>
                <div>
                    <h1>過去のライブ講義のWeb会議室に再入室したい場合は、以下の手順で操作してください。 </h1>
                </div>
                <div><img src="/static\images\ja\newManual\jonh_live_new_5.png" alt="" /></div>
                <div>
                    <p>①.ライブ講義の検索機能を使用し、過去のライブ講義を検索していきます。</p>
                    <p>②.見付かったライブ講義の名称をクリックします（過去のライブ講義であるため、ステータスは「終了」になる）。</p>
                    <p>③.上記の確認メッセージが表示されます。</p>
                    <p>&nbsp;&nbsp;「再参加」ボタンをクリックすると、過去のライブ講義のWeb会議室に入室することができます。 </p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div><p>①.参加したいコース名をクリックして下さい。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\live_course_3_1.png" alt="" /></div>
                <div><p>②. [参加]ボタンをクリックして下さい。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\live_course_3_2.png" alt="" /></div>
                <div><p>③.「参加」ボタンで参加できない場合は、「予備」ボタンをクリックし、ライブl講義に参加してください。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\live_course_3_3.png" alt="" /></div>
                <div><p>※「予備」ボタンで入室した場合に、本コースでは出席を取られない為、講義が終了後自分で出席を取ってください。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\live_course_3_4.png" alt="" /></div>
                <div><p>④.ライブ講義の名称をクリックしても参加できない場合は、過去のライブ講義のWeb会議室に再入室することで一時的に対応してください（このケースは発生頻度は非常に低い、緊急対応手段として利用されます)。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\live_course_4.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/jonhLiveCourse_manual.vue